import React from "react";
import { BookOpenIcon, GiftIcon } from "lucide-react";
import { bonuses, books, heroImage } from "../data/content";
import { SectionHeading } from "./SectionHeading";
import { CheckoutButton } from "./CheckoutButton";
export function WhatYouGet() {
  return <section className="border-t border-line bg-panel px-4 py-14 sm:px-5 sm:py-20" data-id="element-190" data-mp="l5pilol7pcgr">
      <SectionHeading eyebrow="LE PACK COMPLET" title={<>Regardez tout ce que <span className="text-gold" data-id="element-192" data-mp="1dsimugxt8tvi">vous recevez</span></>} data-id="element-191" data-mp="q2o8tw1r8z9o" />
      <div className="mx-auto mt-10 grid max-w-5xl items-center gap-8 lg:grid-cols-[1.1fr_1fr] lg:gap-12" data-id="element-193" data-mp="1ird3pdc7w8cz">
        <img src={heroImage} alt="Les 2 livres complémentaires et les 5 bonus offerts" loading="lazy" className="w-full rounded-2xl border border-line" data-id="element-194" data-mp="1415w5snr09r2" />
        <div data-id="element-195" data-mp="1wptkxy7phh9d">
          <h3 className="text-xs font-bold tracking-widest text-gold" data-id="element-196" data-mp="1wpbhagips0rf">LES 2 LIVRES</h3>
          <ul className="mt-3 space-y-3" data-id="element-197" data-mp="21imncffpcdia">
            {books.map(b => <li key={b.title} className="flex items-center gap-3 rounded-xl border border-gold/40 bg-ink p-3" data-id="element-198" data-mp="2vfaq7bb6dlg4">
                <img src={b.image} alt="" className="h-14 w-14 shrink-0 rounded-lg object-cover" data-id="element-199" data-mp="2qhsexe9oqu4y" />
                <div className="min-w-0 flex-1" data-id="element-200" data-mp="356ov5ylwbdgn">
                  <p className="font-bold text-cream" data-id="element-201" data-mp="357gheitlryu9">{b.title}</p>
                  <p className="text-xs text-mute" data-id="element-202" data-mp="30dc8hu0s1gqj">{b.desc}</p>
                </div>
                <BookOpenIcon className="h-5 w-5 shrink-0 text-gold" aria-hidden data-id="element-203" data-mp="3e5acxrjjmogd" />
              </li>)}
          </ul>

          <h3 className="mt-6 text-xs font-bold tracking-widest text-gold" data-id="element-204" data-mp="396z2pfpc6bxm">LES 5 BONUS OFFERTS</h3>
          <ul className="mt-3 divide-y divide-line rounded-xl border border-line bg-ink" data-id="element-205" data-mp="3o3q0xln9xhln">
            {bonuses.map((b, i) => <li key={b.title} className="flex items-center gap-3 p-3" data-id="element-206" data-mp="1tqgmdffvf5wj" data-mpi={i}>
                <img src={b.image} alt="" className="h-11 w-11 shrink-0 rounded-md object-cover" data-id="element-207" data-mp="1tskrg0piaaye" />
                <p className="min-w-0 flex-1 text-sm text-cream" data-id="element-208" data-mp="1otgk7fm56nap">
                  <span className="mr-1.5 font-bold text-gold" data-id="element-209" data-mp="2egudvu0hjkbe">{i + 1}.</span>
                  {b.title}
                </p>
                <span className="flex shrink-0 items-center gap-1 text-xs font-bold text-gold" data-id="element-210" data-mp="2ihea8vd8ijwh">
                  <GiftIcon className="h-3.5 w-3.5" aria-hidden data-id="element-211" data-mp="2newazyh3lste" />
                  OFFERT
                </span>
              </li>)}
          </ul>
        </div>
      </div>
      <div className="mx-auto mt-10 max-w-xl text-center" data-id="element-212" data-mp="2xdlq5jhm0z5y">
        <CheckoutButton className="w-full" data-id="element-213" data-mp="31fgtetj3pmmd" />
      </div>
    </section>;
}